"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6845],{

/***/ 1144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Catalog_CompareWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./store/catalog/actions.js
var actions = __webpack_require__(35493);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
// EXTERNAL MODULE: ./components/Icons/Close.js
var Close = __webpack_require__(30002);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Icons/Compare.js



var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var Compare = function(param) {
    var _width = param.width, width = _width === void 0 ? "20px" : _width, _height = param.height, height = _height === void 0 ? "20px" : _height;
    return websiteName === "bricostore" ? // Material Design "compare_arrows" (24x24, Apache-2.0). Color via currentColor (was hardcoded fill="white").
    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "fill-current",
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3Zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4Z"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "fill-current",
        width: width,
        height: height,
        viewBox: "0 0 31 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.9548 15.5223C30.9578 15.5435 30.9607 15.5647 30.9647 15.5856C30.9686 15.6065 30.9742 15.6274 30.9798 15.6482L30.9798 15.6482C30.9899 15.6855 30.9999 15.7227 30.9999 15.7601L31 15.7603C31 19.5521 27.9121 22.6362 24.1166 22.6362C20.3204 22.6362 17.2325 19.5521 17.2325 15.7603L17.2326 15.7601C17.2326 15.7227 17.2426 15.6855 17.2527 15.6482L17.2527 15.6482L17.2527 15.6482L17.2527 15.6481L17.2527 15.6481L17.2528 15.648C17.2584 15.6272 17.264 15.6065 17.2678 15.5856C17.2718 15.5647 17.2747 15.5435 17.2777 15.5222C17.2844 15.4741 17.291 15.4262 17.3094 15.3829L17.3095 15.3825L22.5892 2.95773L17.9361 3.40172C17.59 4.41909 16.6349 5.15815 15.5 5.15815C14.5396 5.15815 13.7098 4.62609 13.2647 3.84783L8.30225 4.32133L13.688 16.7388L13.6884 16.7404C13.6885 16.7412 13.6885 16.7421 13.6889 16.7429C13.7023 16.7741 13.7074 16.8086 13.7124 16.8432L13.7124 16.8432C13.7154 16.8637 13.7184 16.8842 13.7232 16.9041C13.7277 16.9234 13.733 16.9427 13.7382 16.9619C13.7525 17.0146 13.7667 17.067 13.7668 17.12L13.767 17.1208L13.7672 17.1214C13.7673 17.1219 13.7675 17.1224 13.7675 17.1229C13.7675 20.9147 10.6796 24 6.88342 24C3.08789 24 0 20.9147 0 17.1229C0 17.1224 0.000156482 17.1219 0.000313544 17.1214L0.000315299 17.1214C0.000472978 17.121 0.000630656 17.1205 0.000630592 17.12C0.000746137 17.067 0.0149952 17.0146 0.0293028 16.9619C0.0345242 16.9427 0.0397534 16.9234 0.0443064 16.9041C0.0490546 16.8842 0.0520593 16.8637 0.0550585 16.8432C0.0601265 16.8086 0.0651786 16.7741 0.0786005 16.7429C0.0788765 16.7422 0.0789553 16.7415 0.0790342 16.7408C0.079113 16.7402 0.0791918 16.7395 0.0794677 16.7388L5.99414 3.10043C6.00455 3.07646 6.02025 3.05715 6.03599 3.0378C6.04707 3.02417 6.05817 3.01052 6.06746 2.9952C6.07523 2.98229 6.08265 2.9693 6.09002 2.95638L6.09005 2.95633C6.11199 2.9179 6.1336 2.88005 6.16332 2.8466C6.16804 2.84129 6.17251 2.83594 6.17696 2.83062L6.17696 2.83062C6.18464 2.82144 6.19225 2.81234 6.20093 2.80363C6.22488 2.77966 6.25245 2.76193 6.28027 2.74404L6.28027 2.74403C6.2943 2.73501 6.30839 2.72595 6.3221 2.71602L6.35025 2.69509C6.3867 2.66775 6.42248 2.64092 6.46456 2.62047C6.47076 2.61745 6.47582 2.61318 6.48087 2.60893C6.48634 2.6043 6.49181 2.59969 6.4987 2.5967C6.50121 2.59563 6.50381 2.59534 6.5064 2.59505C6.50893 2.59477 6.51146 2.59449 6.51391 2.59348C6.54467 2.58076 6.57725 2.57538 6.61003 2.56997C6.62817 2.56698 6.64636 2.56397 6.66433 2.55971C6.68222 2.55543 6.69905 2.54893 6.71585 2.54245L6.71586 2.54245L6.71586 2.54245L6.71586 2.54245L6.71587 2.54244C6.74008 2.53311 6.76421 2.52379 6.79134 2.52115L13.0105 1.92777C13.3016 0.822174 14.3021 0 15.5 0C16.5246 0 17.4039 0.603211 17.8213 1.46836L24.0245 0.876482C24.0324 0.875742 24.0398 0.877214 24.0473 0.878688C24.0541 0.880036 24.0609 0.881386 24.0681 0.881047C24.1379 0.877352 24.2037 0.889201 24.2711 0.901347L24.2843 0.903715C24.2999 0.906526 24.3156 0.908763 24.3312 0.91099C24.3676 0.916181 24.4036 0.921316 24.4381 0.933545C24.446 0.936386 24.4541 0.938281 24.4622 0.940171C24.472 0.94247 24.4818 0.944761 24.4913 0.948735C24.4918 0.948959 24.4924 0.949024 24.493 0.949089C24.4937 0.949161 24.4944 0.949233 24.495 0.949522C24.5055 0.953966 24.5138 0.960844 24.5222 0.967729C24.5295 0.97377 24.5369 0.979818 24.5457 0.984232C24.5616 0.992222 24.5761 1.00251 24.5907 1.0128C24.6 1.01934 24.6092 1.02589 24.6188 1.03185C24.6318 1.03991 24.6449 1.04754 24.658 1.05512L24.658 1.05513L24.658 1.05514C24.6919 1.07486 24.7254 1.09432 24.7551 1.12063C24.7615 1.12625 24.768 1.13132 24.7746 1.13637L24.7746 1.13638L24.7746 1.1364C24.784 1.14358 24.7933 1.15072 24.8018 1.15936C24.8241 1.18174 24.8402 1.20792 24.8564 1.23425C24.8657 1.2494 24.8751 1.2646 24.8856 1.27915L24.9048 1.30489C24.9333 1.34286 24.9612 1.38004 24.9824 1.42389C24.9856 1.43072 24.9903 1.43635 24.9949 1.44197C25 1.44815 25.0051 1.45432 25.0084 1.46206L30.9231 15.3825L30.9231 15.3829C30.9415 15.4262 30.9482 15.4741 30.9548 15.5223ZM20 15H28L24.0002 4L20 15ZM6.99982 5L11 16H3L6.99982 5ZM2 18C2.46571 20.2772 4.52903 22 6.99967 22C9.47089 22 11.5343 20.2772 12 18H2ZM14.5 2C14.2241 2 14 1.77539 14 1.5C14 1.22461 14.2241 1 14.5 1C14.7759 1 15 1.22461 15 1.5C15 1.77539 14.7759 2 14.5 2ZM19 17C19.4657 19.2777 21.5291 21 24.0003 21C26.471 21 28.5343 19.2777 29 17H19Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_Compare = (Compare);

// EXTERNAL MODULE: ./lib/clientStore.js
var clientStore = __webpack_require__(66208);
;// CONCATENATED MODULE: ./containers/Catalog/CompareWidget.js












var CompareWidget_ref = (0,config["default"])(), settings = CompareWidget_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
// Brico: the compare bar is red (was black) with a Macan Stencil first letter on "Compara".
// The trigger <div>s are flex containers, so wrap the label in an inline-block block-container
// for ::first-letter to fire (see .bd-claim in bricostore-typography.css).
var compareBg = isBricoStore ? "bg-red-brand" : "bg-black";
// Brico: round the modal's left corners too (to match the right)
var modalTopRadius = isBricoStore ? "rounded-t-lg" : "rounded-tr-lg";
var CompareLabel = function() {
    return isBricoStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "bd-claim inline-block",
        children: "Compara"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Compara"
    });
};
var CompareWidget = function(param) {
    var compareList = param.compareList, removeFromCompare1 = param.removeFromCompare, toggleCompare1 = param.toggleCompare, compareVisible = param.compareVisible, isPromoToastVisible = param.isPromoToastVisible, userDismissedNewsletter = param.userDismissedNewsletter, // PDP mobile: lift the widget above the sticky add-to-cart bar so they don't overlap
    showsStickyCta = param.showsStickyCta;
    if (!(compareList === null || compareList === void 0 ? void 0 : compareList.length)) {
        return null;
    }
    // TDOD add a way to update redux state for the user to dismiss the newsletter popup
    var isCookieConsentPopupVisible = Boolean(!clientStore/* cookieClientStore.get */.u.get("CookieConsent"));
    var isNewsletterPopupVisible = !userDismissedNewsletter;
    var classes = classnames_default()("Compare fixed right-15px rounded-tr-lg rounded-bl-lg z-10 bottom-6", {
        "Compare-is-expanded": compareVisible,
        // lift above the mobile sticky add-to-cart bar (~67px); no lift on desktop (bar is md:hidden)
        "-translate-y-[72px] md:translate-y-0": showsStickyCta,
        // only cookies are visible
        "bottom-[10px] xl:bottom-[200px]": isCookieConsentPopupVisible && !isNewsletterPopupVisible && !isPromoToastVisible,
        // cookies and newsletter OR toast are visible
        "bottom-[110px] sm:bottom-[115px] xl:bottom-[310px]": isCookieConsentPopupVisible && (!isNewsletterPopupVisible && isPromoToastVisible || isNewsletterPopupVisible && !isPromoToastVisible),
        // all are visible
        "bottom-[110px] sm:bottom-[210px] xl:bottom-[400px]": isCookieConsentPopupVisible && isNewsletterPopupVisible && isPromoToastVisible,
        // newsletter AND toast are visible
        "bottom-[120px] sm:bottom-[210px]": !isCookieConsentPopupVisible && isNewsletterPopupVisible && isPromoToastVisible,
        // nesletter OR toast is visible
        "bottom-32 sm:bottom-28": !isCookieConsentPopupVisible && (isNewsletterPopupVisible && !isPromoToastVisible || !isNewsletterPopupVisible && isPromoToastVisible)
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes,
        id: "compare-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden md:flex ".concat(compareBg, " ").concat(modalTopRadius, " text-white cursor-pointer p-4 text-lg leading-3 items-center justify-between"),
                onClick: function() {
                    return toggleCompare1();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareLabel, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        customClassName: "fill-current inline-block transition-all duration-[400ms] ease-in-out  ".concat(compareVisible ? "rotate-0" : "rotate-180")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "\n            rounded-full text-white float-right cursor-pointer items-center justify-center w-[64px] h-[64px]\n            ".concat(compareVisible ? "hidden" : "flex", " md:hidden relative\n            ").concat(compareList.length > 1 ? compareBg : "bg-gray-1000", "\n          "),
                onClick: function() {
                    return toggleCompare1();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute top-0 left-0 bg-red-brand text-white text-xs text-center leading-[16px] w-[19px] rounded-[4px]",
                        children: compareList.length
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Compare, {
                        width: "31px",
                        height: "24px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Compare-content ".concat(modalTopRadius, " md:rounded-none bg-white border ").concat(compareVisible ? "block" : "hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex md:hidden ".concat(compareBg, " ").concat(modalTopRadius, " text-white cursor-pointer\n              p-4 text-lg leading-3 items-center justify-between"),
                        onClick: function() {
                            return toggleCompare1();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareLabel, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "List border-[#C7C7C7]",
                        children: compareList.map(function(product) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                className: "flex items-center justify-between px-3 py-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,helpers/* resizeImage */.tg)(product.thumbnail, "56x56"),
                                        alt: product.name,
                                        width: "47",
                                        height: "47",
                                        className: "Compare-image box-border flex-none pr-[7px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "".concat(settings.baseUrl, "/").concat(product.url_key, "/cpd/").concat(product.sku, "/"),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "Compare-name truncate-3-lines text-black text-[10px] mr-[17px]",
                                            children: product.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "Compare-remove cursor-pointer text-center text-gray-light",
                                        onClick: function() {
                                            return removeFromCompare1(product.sku);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                            width: "14px",
                                            height: "14px"
                                        })
                                    })
                                ]
                            }, product.sku);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-4 pb-[22px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            href: compareList.length === 1 ? "" : "/compara/",
                            title: "Compara produse",
                            variant: "primary",
                            display: "block",
                            disabled: compareList.length === 1
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Catalog_CompareWidget = ((0,es/* connect */.$j)(function(state) {
    return {
        compareList: state.catalog.compare,
        compareVisible: state.catalog.compareVisible,
        isPromoToastVisible: state.app.isPromoToastVisible,
        userDismissedNewsletter: state.app.userDismissedNewsletter
    };
}, {
    removeFromCompare: actions/* removeFromCompare */.q7,
    toggleCompare: actions/* toggleCompare */.pf
})(CompareWidget));


/***/ }),

/***/ 86845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_Promo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./containers/Promo/PromoBanner.js



var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var PromoBanner = function(param) {
    var small = param.small, medium = param.medium, large = param.large;
    if (small && medium) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(settings.cdn).concat(small),
                    className: "sm:hidden",
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(settings.cdn).concat(medium),
                    className: "hidden sm:block lg:hidden",
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(settings.cdn).concat(large),
                    className: "hidden lg:block",
                    alt: ""
                })
            ]
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: "".concat(settings.cdn).concat(large),
        alt: ""
    }));
};
/* harmony default export */ var Promo_PromoBanner = (PromoBanner);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ./containers/Promo/PromoMainMenu/PromoMainMenuFilters.js


var PromoMainMenuFilters = function(param) {
    var filters = param.filters, activeFilters = param.activeFilters, onChange = param.onChange;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: sortBy_default()(filters, "order").map(function(filter) {
            var hasFilter = activeFilters[filter.attribute_code];
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2",
                        children: filter.label
                    }),
                    filter.options && sortBy_default()(filter.options, "order").map(function(option) {
                        var isActive = hasFilter && activeFilters[filter.attribute_code].includes(option.value);
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "capitalize leading-18.2 -tracking-0.39 cursor-pointer select-none ".concat(isActive ? "is-active" : ""),
                                onClick: function(event) {
                                    event.preventDefault();
                                    onChange({
                                        filter: filter,
                                        option: option
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "checkbox-control inline-block align-middle w-5 h-5 p-1 mr-2 border-gray-light border-2 rounded-4px bg-white ".concat(isActive ? "checked" : "group-with-promoDarkTheme:bg-black"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            "aria-hidden": "true",
                                            focusable: "false",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "3",
                                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                                            })
                                        })
                                    }),
                                    option.label,
                                    " (",
                                    option.count,
                                    ")"
                                ]
                            })
                        }, option.slug));
                    })
                ]
            }, filter.slug));
        })
    }));
};
/* harmony default export */ var PromoMainMenu_PromoMainMenuFilters = (PromoMainMenuFilters);

// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
// EXTERNAL MODULE: ./node_modules/string.prototype.replaceall/index.js
var string_prototype_replaceall = __webpack_require__(97979);
var string_prototype_replaceall_default = /*#__PURE__*/__webpack_require__.n(string_prototype_replaceall);
;// CONCATENATED MODULE: ./containers/Promo/PromoMainMenu/PromoMainMenuSubCategory.js






var PromoMainMenuSubCategory_ref = (0,config["default"])(), _publicRuntimeConfig = PromoMainMenuSubCategory_ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
// Brico: categories in black (white on dark-theme campaigns, where an explicit
// colour would override the menu wrapper's white), selected category in brand
// red, first letter in Macan Stencil.
var categoryClass = isBricoStore ? "text-ironBlack group-with-promoDarkTheme:text-white" : "";
var activeCategoryClass = isBricoStore ? "text-red-brand" : "text-green";
var renderName = function(label) {
    return isBricoStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "bd-claim inline-block first-letter:uppercase",
        children: label
    }) : label;
};
var PromoMainMenuSubCategory = function(param) {
    var id = param.id, currentPageCategory = param.currentPageCategory, name = param.name, link = param.link, subcategories = param.subcategories, activeTree = param.activeTree, onSetActive = param.onSetActive, isActive = param.isActive, slug = param.slug, filters = param.filters, activeFilters = param.activeFilters, onFiltersChange = param.onFiltersChange;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            !isActive && !subcategories && currentPageCategory !== id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-3 ".concat(categoryClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "block",
                        children: renderName(name)
                    })
                })
            }),
            (!isActive && subcategories || !isActive && currentPageCategory === id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center py-3 cursor-pointer ".concat(categoryClass),
                onClick: function() {
                    return onSetActive({
                        subCategorySlug: slug
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat(link),
                        title: "",
                        onClick: function(event) {
                            return event.preventDefault();
                        },
                        className: "block",
                        children: renderName(name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        width: "10px"
                    })
                ]
            }),
            isActive && !subcategories && filters && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center py-3 cursor-pointer font-medium ".concat(activeCategoryClass),
                        onClick: function() {
                            return onSetActive({
                                subCategorySlug: null
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(link),
                                title: "",
                                onClick: function(event) {
                                    return event.preventDefault();
                                },
                                className: "block",
                                children: renderName(name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rotate-180",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                    width: "10px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-1 ml-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoMainMenu_PromoMainMenuFilters, {
                            filters: filters,
                            activeFilters: activeFilters,
                            onChange: onFiltersChange
                        })
                    })
                ]
            }),
            isActive && !subcategories && !filters && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-between items-center py-3 font-medium ".concat(activeCategoryClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "".concat(link),
                    title: "",
                    onClick: function(event) {
                        return event.preventDefault();
                    },
                    className: "block",
                    children: renderName(name)
                })
            }),
            isActive && subcategories && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center py-3 cursor-pointer border-b border-[#A2A2A2] font-medium ".concat(activeCategoryClass),
                        onClick: function() {
                            return onSetActive({
                                subCategorySlug: null
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(link),
                                title: "",
                                onClick: function(event) {
                                    return event.preventDefault();
                                },
                                className: "block",
                                children: renderName(name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rotate-180",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                    width: "10px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "list-none ml-4",
                        children: subcategories.map(function(subcategory, index) {
                            var isSubSubCategoryActive = activeTree.subSubCategorySlug === subcategory.slug;
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "".concat(index + 1 !== subcategories.length ? "border-b border-[#A2A2A2]" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoMainMenuSubCategory, {
                                    id: subcategory.id,
                                    link: string_prototype_replaceall_default()("".concat(link, "/").concat(subcategory.slug, "/"), "//", "/"),
                                    name: subcategory.name,
                                    slug: subcategory.slug,
                                    subcategories: subcategory.subcategories,
                                    filters: subcategory.filters,
                                    activeFilters: activeFilters,
                                    onFiltersChange: onFiltersChange,
                                    isActive: isSubSubCategoryActive,
                                    activeTree: activeTree,
                                    onSetActive: function() {
                                        return onSetActive({
                                            subCategorySlug: slug,
                                            subSubCategorySlug: isSubSubCategoryActive ? null : subcategory.slug
                                        });
                                    }
                                })
                            }, subcategory.id));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PromoMainMenu_PromoMainMenuSubCategory = (PromoMainMenuSubCategory);

;// CONCATENATED MODULE: ./containers/Promo/PromoMainMenu/PromoMainMenuCategory.js







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PromoMainMenuCategory_ref = (0,config["default"])(), PromoMainMenuCategory_publicRuntimeConfig = PromoMainMenuCategory_ref.publicRuntimeConfig, PromoMainMenuCategory_websiteName = PromoMainMenuCategory_publicRuntimeConfig.settings.websiteName;
var PromoMainMenuCategory_isBricoStore = PromoMainMenuCategory_websiteName === "bricostore";
// Brico: categories in black (white on dark-theme campaigns, where an explicit
// colour would override the menu wrapper's white), selected category in brand
// red, first letter in Macan Stencil.
var PromoMainMenuCategory_categoryClass = PromoMainMenuCategory_isBricoStore ? "text-ironBlack group-with-promoDarkTheme:text-white" : "";
var PromoMainMenuCategory_activeCategoryClass = PromoMainMenuCategory_isBricoStore ? "text-red-brand" : "text-green";
var activeCategoryDarkClass = PromoMainMenuCategory_isBricoStore ? "text-red-brand" : "text-green group-with-promoDarkTheme:text-green";
var PromoMainMenuCategory_renderName = function(label) {
    return PromoMainMenuCategory_isBricoStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "bd-claim inline-block first-letter:uppercase",
        children: label
    }) : label;
};
var PromoMainMenuCategory = function(param) {
    var id = param.id, name = param.name, link = param.link, subcategories = param.subcategories, activeTree = param.activeTree, onSetActive = param.onSetActive, isActive = param.isActive, slug = param.slug, filters = param.filters, activeFilters = param.activeFilters, onFiltersChange = param.onFiltersChange, currentPageCategory = param.currentPageCategory;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            !isActive && !subcategories && currentPageCategory !== id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-3 ".concat(PromoMainMenuCategory_categoryClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "".concat(link),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "block font-semibold",
                        children: PromoMainMenuCategory_renderName(name)
                    })
                })
            }),
            (!isActive && subcategories || !isActive && currentPageCategory === id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center py-3 cursor-pointer font-semibold ".concat(PromoMainMenuCategory_categoryClass),
                onClick: function() {
                    return onSetActive({
                        categorySlug: slug
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat(link),
                        title: "",
                        onClick: function(event) {
                            return event.preventDefault();
                        },
                        className: "block",
                        children: PromoMainMenuCategory_renderName(name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        width: "10px"
                    })
                ]
            }),
            isActive && !subcategories && filters && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center py-3 cursor-pointer font-semibold group-with-promoDarkTheme:text-white ".concat(activeCategoryDarkClass),
                        onClick: function() {
                            return onSetActive({
                                categorySlug: null
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(link),
                                title: "",
                                onClick: function(event) {
                                    return event.preventDefault();
                                },
                                className: "block",
                                children: PromoMainMenuCategory_renderName(name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rotate-180",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                    width: "10px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-1 ml-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoMainMenu_PromoMainMenuFilters, {
                            filters: filters,
                            activeFilters: activeFilters,
                            onChange: onFiltersChange
                        })
                    })
                ]
            }),
            isActive && !subcategories && !filters && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-between items-center py-3 font-semibold ".concat(PromoMainMenuCategory_activeCategoryClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "".concat(link),
                    title: "",
                    onClick: function(event) {
                        return event.preventDefault();
                    },
                    className: "block",
                    children: PromoMainMenuCategory_renderName(name)
                })
            }),
            isActive && subcategories && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center py-3 cursor-pointer border-b border-[#A2A2A2] font-semibold ".concat(PromoMainMenuCategory_activeCategoryClass),
                        onClick: function() {
                            return onSetActive({
                                categorySlug: null
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(link),
                                title: "",
                                onClick: function(event) {
                                    return event.preventDefault();
                                },
                                className: "block",
                                children: PromoMainMenuCategory_renderName(name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rotate-180",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                    width: "10px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "list-none ml-4",
                        children: subcategories.map(function(subcategory, index) {
                            var isSubCategoryActive = activeTree.subCategorySlug === subcategory.slug;
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "".concat(index + 1 !== subcategories.length ? "border-b border-[#A2A2A2]" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoMainMenu_PromoMainMenuSubCategory, {
                                    id: subcategory.id,
                                    currentPageCategory: currentPageCategory,
                                    link: string_prototype_replaceall_default()("".concat(link, "/").concat(subcategory.slug, "/"), "//", "/"),
                                    name: subcategory.name,
                                    slug: subcategory.slug,
                                    subcategories: subcategory.subcategories,
                                    filters: subcategory.filters,
                                    activeFilters: activeFilters,
                                    onFiltersChange: onFiltersChange,
                                    isActive: isSubCategoryActive,
                                    activeTree: activeTree,
                                    onSetActive: function(params) {
                                        return onSetActive(_objectSpread({
                                            categorySlug: slug
                                        }, params));
                                    }
                                })
                            }, subcategory.id));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PromoMainMenu_PromoMainMenuCategory = (PromoMainMenuCategory);

;// CONCATENATED MODULE: ./containers/Promo/PromoMainMenu/index.js



var PromoMainMenu = function(param1) {
    var categories = param1.categories, context = param1.context, campaignSlug = param1.campaignSlug, onFiltersChange = param1.onFiltersChange, activeFilters = param1.activeFilters, currentPageCategory = param1.currentPageCategory;
    var ref = (0,react.useState)({
        categorySlug: null,
        subCategorySlug: null,
        subSubCategorySlug: null
    }), /*#__PURE__*/ activeTree = ref[0], setActiveTree = ref[1];
    // TODO: check logic and refactor
    (0,react.useEffect)(function() {
        setActiveTree({
            categorySlug: context.categoryLevel1 || categories[0].slug,
            subCategorySlug: context.categoryLevel2 || null,
            subSubCategorySlug: context.categoryLevel3 || null
        });
    }, [
        context.categoryLevel1,
        context.categoryLevel2,
        context.categoryLevel3
    ]);
    var handleSetActive = function(param) {
        var categorySlug = param.categorySlug, subCategorySlug = param.subCategorySlug, subSubCategorySlug = param.subSubCategorySlug;
        setActiveTree({
            categorySlug: categorySlug,
            subCategorySlug: subCategorySlug,
            subSubCategorySlug: subSubCategorySlug
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "group-with-promoDarkTheme:text-white",
        children: categories.map(function(category) {
            var isActiveCategory = activeTree.categorySlug === category.slug;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-b border-[#A2A2A2]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoMainMenu_PromoMainMenuCategory, {
                    id: category.id,
                    currentPageCategory: currentPageCategory,
                    name: category.name,
                    slug: category.slug,
                    link: "/promo/".concat(campaignSlug, "/").concat(category.slug),
                    isActive: isActiveCategory,
                    activeTree: {
                        category: activeTree.categorySlug,
                        subCategorySlug: activeTree.subCategorySlug,
                        subSubCategorySlug: activeTree.subSubCategorySlug
                    },
                    subcategories: category.subcategories,
                    onSetActive: handleSetActive,
                    filters: category.filters,
                    activeFilters: activeFilters,
                    onFiltersChange: onFiltersChange
                })
            }, category.id));
        })
    }));
};
/* harmony default export */ var Promo_PromoMainMenu = (PromoMainMenu);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./containers/Promo/PromoMobileMenu/PromoMobileMenuSubCategory.js





var PromoMobileMenuSubCategory_ref = (0,config["default"])(), PromoMobileMenuSubCategory_publicRuntimeConfig = PromoMobileMenuSubCategory_ref.publicRuntimeConfig, PromoMobileMenuSubCategory_websiteName = PromoMobileMenuSubCategory_publicRuntimeConfig.settings.websiteName;
var PromoMobileMenuSubCategory_isBricoStore = PromoMobileMenuSubCategory_websiteName === "bricostore";
// Brico: categories in black (white on dark-theme campaigns, where an explicit
// colour would override the menu wrapper's white), selected category in brand
// red, first letter in Macan Stencil.
var PromoMobileMenuSubCategory_categoryClass = PromoMobileMenuSubCategory_isBricoStore ? "text-ironBlack group-with-promoDarkTheme:text-white" : "";
var PromoMobileMenuSubCategory_activeCategoryClass = PromoMobileMenuSubCategory_isBricoStore ? "text-red-brand" : "text-green";
var PromoMobileMenuSubCategory_renderName = function(label) {
    return PromoMobileMenuSubCategory_isBricoStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "bd-claim inline-block first-letter:uppercase",
        children: label
    }) : label;
};
var PromoMobileMenuSubCategory = function(param) {
    var currentPageCategory = param.currentPageCategory, id = param.id, name = param.name, link = param.link, subcategories = param.subcategories, activeTree = param.activeTree, onSetActive = param.onSetActive, isActive = param.isActive, slug = param.slug;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            !isActive && !subcategories && currentPageCategory !== id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-3 ".concat(PromoMobileMenuSubCategory_categoryClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "block",
                        children: PromoMobileMenuSubCategory_renderName(name)
                    })
                })
            }),
            (!isActive && subcategories || !isActive && currentPageCategory === id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center py-3 cursor-pointer ".concat(PromoMobileMenuSubCategory_categoryClass),
                onClick: function() {
                    return onSetActive({
                        subCategorySlug: slug
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat(link),
                        title: "",
                        onClick: function(event) {
                            return event.preventDefault();
                        },
                        className: "block",
                        children: PromoMobileMenuSubCategory_renderName(name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        width: "10px"
                    })
                ]
            }),
            isActive && !subcategories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-between items-center py-3 font-medium ".concat(PromoMobileMenuSubCategory_activeCategoryClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "".concat(link),
                    title: "",
                    onClick: function(event) {
                        return event.preventDefault();
                    },
                    className: "block",
                    children: PromoMobileMenuSubCategory_renderName(name)
                })
            }),
            isActive && subcategories && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center py-3 cursor-pointer border-b border-[#A2A2A2] font-medium ".concat(PromoMobileMenuSubCategory_activeCategoryClass),
                        onClick: function() {
                            return onSetActive({
                                subCategorySlug: null
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(link),
                                title: "",
                                onClick: function(event) {
                                    return event.preventDefault();
                                },
                                className: "block",
                                children: PromoMobileMenuSubCategory_renderName(name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rotate-180",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                    width: "10px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "list-none ml-4",
                        children: subcategories.map(function(subcategory, index) {
                            var isSubSubCategoryActive = activeTree.subSubCategorySlug === subcategory.slug;
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "".concat(index + 1 !== subcategories.length ? "border-b border-[#A2A2A2]" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoMobileMenuSubCategory, {
                                    id: subcategory.id,
                                    link: string_prototype_replaceall_default()("".concat(link, "/").concat(subcategory.slug, "/"), "//", "/"),
                                    name: subcategory.name,
                                    slug: subcategory.slug,
                                    subcategories: subcategory.subcategories,
                                    filters: subcategory.filters,
                                    isActive: isSubSubCategoryActive,
                                    activeTree: activeTree,
                                    onSetActive: function() {
                                        return onSetActive({
                                            subCategorySlug: slug,
                                            subSubCategorySlug: isSubSubCategoryActive ? null : subcategory.slug
                                        });
                                    }
                                })
                            }, subcategory.id));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PromoMobileMenu_PromoMobileMenuSubCategory = (PromoMobileMenuSubCategory);

;// CONCATENATED MODULE: ./containers/Promo/PromoMobileMenu/PromoMobileMenuCategory.js






function PromoMobileMenuCategory_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PromoMobileMenuCategory_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PromoMobileMenuCategory_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PromoMobileMenuCategory_ref = (0,config["default"])(), PromoMobileMenuCategory_publicRuntimeConfig = PromoMobileMenuCategory_ref.publicRuntimeConfig, PromoMobileMenuCategory_websiteName = PromoMobileMenuCategory_publicRuntimeConfig.settings.websiteName;
var PromoMobileMenuCategory_isBricoStore = PromoMobileMenuCategory_websiteName === "bricostore";
// Brico: categories in black (white on dark-theme campaigns, where an explicit
// colour would override the menu wrapper's white), selected category in brand
// red, first letter in Macan Stencil.
var PromoMobileMenuCategory_categoryClass = PromoMobileMenuCategory_isBricoStore ? "text-ironBlack group-with-promoDarkTheme:text-white" : "";
var PromoMobileMenuCategory_activeCategoryClass = PromoMobileMenuCategory_isBricoStore ? "text-red-brand" : "text-green";
var PromoMobileMenuCategory_renderName = function(label) {
    return PromoMobileMenuCategory_isBricoStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "bd-claim inline-block first-letter:uppercase",
        children: label
    }) : label;
};
var PromoMobileMenuCategory_PromoMainMenuCategory = function(param) {
    var currentPageCategory = param.currentPageCategory, id = param.id, name = param.name, link = param.link, subcategories = param.subcategories, activeTree = param.activeTree, onSetActive = param.onSetActive, isActive = param.isActive, slug = param.slug;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            !isActive && !subcategories && currentPageCategory !== id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-3 ".concat(PromoMobileMenuCategory_categoryClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "".concat(link),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "block font-semibold",
                        children: PromoMobileMenuCategory_renderName(name)
                    })
                })
            }),
            (!isActive && subcategories || !isActive && currentPageCategory === id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center py-3 cursor-pointer font-semibold ".concat(PromoMobileMenuCategory_categoryClass),
                onClick: function() {
                    return onSetActive({
                        categorySlug: slug
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat(link),
                        title: "",
                        onClick: function(event) {
                            return event.preventDefault();
                        },
                        className: "block",
                        children: PromoMobileMenuCategory_renderName(name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        width: "10px"
                    })
                ]
            }),
            isActive && !subcategories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-between items-center py-3 font-semibold ".concat(PromoMobileMenuCategory_activeCategoryClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "".concat(link),
                    title: "",
                    onClick: function(event) {
                        return event.preventDefault();
                    },
                    className: "block",
                    children: PromoMobileMenuCategory_renderName(name)
                })
            }),
            isActive && subcategories && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center py-3 cursor-pointer border-b border-[#A2A2A2] font-semibold ".concat(PromoMobileMenuCategory_activeCategoryClass),
                        onClick: function() {
                            return onSetActive({
                                categorySlug: null
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(link),
                                title: "",
                                onClick: function(event) {
                                    return event.preventDefault();
                                },
                                className: "block",
                                children: PromoMobileMenuCategory_renderName(name)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rotate-180",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                    width: "10px"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "list-none ml-4",
                        children: subcategories.map(function(subcategory, index) {
                            var isSubCategoryActive = activeTree.subCategorySlug === subcategory.slug;
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "".concat(index + 1 !== subcategories.length ? "border-b border-[#A2A2A2]" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoMobileMenu_PromoMobileMenuSubCategory, {
                                    id: subcategory.id,
                                    link: string_prototype_replaceall_default()("".concat(link, "/").concat(subcategory.slug, "/"), "//", "/"),
                                    name: subcategory.name,
                                    slug: subcategory.slug,
                                    subcategories: subcategory.subcategories,
                                    filters: subcategory.filters,
                                    isActive: isSubCategoryActive,
                                    activeTree: activeTree,
                                    onSetActive: function(params) {
                                        return onSetActive(PromoMobileMenuCategory_objectSpread({
                                            categorySlug: slug
                                        }, params));
                                    }
                                })
                            }, subcategory.id));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PromoMobileMenuCategory = (PromoMobileMenuCategory_PromoMainMenuCategory);

;// CONCATENATED MODULE: ./components/Icons/Menu.js



var Menu_ref = (0,config["default"])(), Menu_publicRuntimeConfig = Menu_ref.publicRuntimeConfig, Menu_websiteName = Menu_publicRuntimeConfig.settings.websiteName;
var Menu = function(param) {
    var _width = param.width, width = _width === void 0 ? "24px" : _width, _height = param.height, height = _height === void 0 ? "18px" : _height, fill = param.fill;
    return Menu_websiteName === "bricostore" ? // Material Design "menu" (24x24, Apache-2.0). Honor the fill prop, else currentColor.
    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "fill-current",
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: fill || "currentColor",
            d: "M3 18h18v-2H3v2Zm0-5h18v-2H3v2Zm0-7v2h18V6H3Z"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "fill-current",
        width: width,
        height: height,
        viewBox: "0 0 24 18",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "translate(-10.000000, -127.000000)",
                fill: fill,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "10",
                        y: "135",
                        width: "24",
                        height: "2",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "10",
                        y: "143",
                        width: "24",
                        height: "2",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "10",
                        y: "127",
                        width: "24",
                        height: "2",
                        rx: "1"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Icons_Menu = (Menu);

// EXTERNAL MODULE: ./components/Icons/MainMenu.js
var MainMenu = __webpack_require__(33816);
;// CONCATENATED MODULE: ./containers/Promo/PromoMobileMenu/index.js







var PromoMobileMenu_ref = (0,config["default"])(), PromoMobileMenu_publicRuntimeConfig = PromoMobileMenu_ref.publicRuntimeConfig, PromoMobileMenu_websiteName = PromoMobileMenu_publicRuntimeConfig.settings.websiteName;
var PromoMobileMenu_isBricoStore = PromoMobileMenu_websiteName === "bricostore";
var PromoMobileMenu = function(param1) {
    var categories = param1.categories, context = param1.context, campaignSlug = param1.campaignSlug, currentPageCategory = param1.currentPageCategory;
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref1 = (0,react.useState)({
        categorySlug: null,
        subCategorySlug: null,
        subSubCategorySlug: null
    }), activeTree = ref1[0], setActiveTree = ref1[1];
    // TODO: check logic and refactor
    (0,react.useEffect)(function() {
        if (isOpen) {
            setIsOpen(!isOpen);
        }
        setActiveTree({
            categorySlug: context.categoryLevel1 || categories[0].slug,
            subCategorySlug: context.categoryLevel2 || null,
            subSubCategorySlug: context.categoryLevel3 || null
        });
    }, [
        context.categoryLevel1,
        context.categoryLevel2,
        context.categoryLevel3
    ]);
    var handleSetActive = function(param) {
        var categorySlug = param.categorySlug, subCategorySlug = param.subCategorySlug, subSubCategorySlug = param.subSubCategorySlug;
        setActiveTree({
            categorySlug: categorySlug,
            subCategorySlug: subCategorySlug,
            subSubCategorySlug: subSubCategorySlug
        });
    };
    var handleMobileMenuToggle = function() {
        setIsOpen(!isOpen);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-[#EDEDED] group-with-promoDarkTheme:bg-[#2E2E2E] group-with-promoDarkTheme:text-white p-2 px-3 sm:px-4 lg:p-0 lg:w-auto lg:bg-transparent group-with-promoDarkTheme:lg:bg-transparent relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: classnames_default()("lg:hidden flex items-center outline-none font-bold text-sm py-1 w-full group-with-promoDarkTheme:text-white", {
                    // Brico: brand-red icon + title, and the homepage animated hamburger→X.
                    "text-red-brand": PromoMobileMenu_isBricoStore,
                    opened: PromoMobileMenu_isBricoStore && isOpen
                }),
                onClick: handleMobileMenuToggle,
                children: [
                    PromoMobileMenu_isBricoStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pointer-events-none flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenu/* default */.Z, {
                            width: "28px",
                            height: "28px"
                        })
                    }) : !isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Menu, {
                        width: "20px"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                x: "1.33789",
                                y: "0.324463",
                                width: "20",
                                height: "1.89189",
                                rx: "0.945946",
                                transform: "rotate(45 1.33789 0.324463)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                x: "15.7285",
                                y: "1.33789",
                                width: "20",
                                height: "1.89189",
                                rx: "0.945946",
                                transform: "rotate(135 15.7285 1.33789)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2 text-base font-medium",
                        children: "Categorii de oferte"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(isOpen ? "absolute " : "hidden", " inset-x-0 top-[45px] bg-[#EDEDED] group-with-promoDarkTheme:bg-[#2E2E2E] z-50 px-10"),
                children: categories.map(function(category) {
                    var isActiveCategory = activeTree.categorySlug === category.slug;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-b border-[#A2A2A2] max-w-[480px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoMobileMenuCategory, {
                            id: category.id,
                            currentPageCategory: currentPageCategory,
                            name: category.name,
                            slug: category.slug,
                            link: "/promo/".concat(campaignSlug, "/").concat(category.slug),
                            isActive: isActiveCategory,
                            activeTree: {
                                category: activeTree.categorySlug,
                                subCategorySlug: activeTree.subCategorySlug,
                                subSubCategorySlug: activeTree.subSubCategorySlug
                            },
                            subcategories: category.subcategories,
                            onSetActive: handleSetActive
                        })
                    }, category.id));
                })
            })
        ]
    }));
};
/* harmony default export */ var Promo_PromoMobileMenu = (PromoMobileMenu);

;// CONCATENATED MODULE: ./containers/Promo/PromoMobileProductsFilters.js


var PromoMobileProductsFilters = function(param) {
    var filters = param.filters, onFiltersChange = param.onFiltersChange, activeFilters = param.activeFilters;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
        className: "ml-2 mt-4 group-with-promoDarkTheme:text-white",
        children: sortBy_default()(filters, "order").map(function(filter) {
            var hasFilter = activeFilters[filter.attribute_code];
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 font-medium",
                        children: filter.label
                    }),
                    filter.options && sortBy_default()(filter.options, "order").map(function(option) {
                        var isActive = hasFilter && activeFilters[filter.attribute_code].includes(option.value);
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "capitalize leading-18.2 -tracking-0.39 cursor-pointer select-none ".concat(isActive ? "is-active" : ""),
                                onClick: function(event) {
                                    event.preventDefault();
                                    onFiltersChange({
                                        filter: filter,
                                        option: option
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "checkbox-control inline-block align-middle w-5 h-5 p-1 mr-2 border-gray-light border-2 rounded-4px bg-white ".concat(isActive ? "checked" : "group-with-promoDarkTheme:bg-black"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: "",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            "aria-hidden": "true",
                                            focusable: "false",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "3",
                                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                                            })
                                        })
                                    }),
                                    option.label,
                                    " (",
                                    option.count,
                                    ")"
                                ]
                            })
                        }, option.slug));
                    })
                ]
            }, filter.slug));
        })
    });
};
/* harmony default export */ var Promo_PromoMobileProductsFilters = (PromoMobileProductsFilters);

;// CONCATENATED MODULE: ./containers/Promo/PromoMobileProductsFiltersToggle.js


var PromoMobileProductsFiltersToggle = function(param) {
    var onClick = param.onClick, isActive = param.isActive;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("button", {
        className: "flex justify-between items-center py-2 px-5 pr-[10px] border rounded-bl-lg rounded-tr-lg bg-white border-primary w-full h-[50px]",
        onClick: onClick,
        children: [
            "Filtreaza",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: isActive ? "rotate-180 mt-[6px]" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var Promo_PromoMobileProductsFiltersToggle = (PromoMobileProductsFiltersToggle);

// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./components/Status.js
var Status = __webpack_require__(66552);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./components/ProductCardLabel.js
var ProductCardLabel = __webpack_require__(34532);
// EXTERNAL MODULE: ./components/Price/index.js + 1 modules
var Price = __webpack_require__(40641);
// EXTERNAL MODULE: ./components/Ratings/index.js + 1 modules
var Ratings = __webpack_require__(57983);
// EXTERNAL MODULE: ./store/tracker/actions.js + 1 modules
var actions = __webpack_require__(48712);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToCart.js + 6 modules
var AddToCart = __webpack_require__(38973);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToCompare.js
var AddToCompare = __webpack_require__(23915);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToWishlist.js + 1 modules
var AddToWishlist = __webpack_require__(9614);
;// CONCATENATED MODULE: ./containers/Promo/PromoProduct/index.js

















function PromoProduct_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PromoProduct_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PromoProduct_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var PromoProduct_ref = (0,config["default"])(), PromoProduct_settings = PromoProduct_ref.publicRuntimeConfig.settings;
var PromoProduct_isBricoStore = PromoProduct_settings.websiteName === "bricostore";
// Brico: offer label top-left; favorite/compare top-RIGHT and HIGH (George). The label's
// right edge (right-[52px]) stops before the ~32px buttons so it never runs under them.
var cornerLabelPos = PromoProduct_isBricoStore ? "top-10px left-11px right-[52px] lg:top-15px lg:left-16px items-start" : "top-0 right-0 items-end";
var actionsPos = PromoProduct_isBricoStore ? "top-10px right-11px lg:top-15px lg:right-16px" : "top-10px left-11px lg:top-15px lg:left-16px";
// Brico: don't clip the ribbon point/eyelet + small gap between labels (width is bounded
// by the left/right positions above, so a long label truncates before the buttons;
// max-w-[85%] kept as a safety cap, matching the category card).
var cornerLabelBox = PromoProduct_isBricoStore ? "overflow-visible gap-1 max-w-[85%]" : "truncate max-w-[75%]";
var LinkWrapper = function(_param) {
    var children = _param.children, href = _param.href, props = _objectWithoutProperties(_param, [
        "children",
        "href"
    ]);
    if (href) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", PromoProduct_objectSpread({}, props, {
                children: children
            }))
        }));
    } else {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", PromoProduct_objectSpread({}, props, {
            children: children
        })));
    }
};
var Product = function(param) {
    var product = param.product, isTeaser = param.isTeaser;
    var ref1 = (0,helpers/* productHelper */.gU)(product), isDisabled = ref1.isDisabled, isWestaco = ref1.isWestaco, getLabels = ref1.getLabels, hasPricePerFactor = ref1.hasPricePerFactor, hasPriceUnit = ref1.hasPriceUnit;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("Product flex flex-col relative bg-white max-h-[490px]", {
            "hover:shadow-mixRedYellow": !isTeaser,
            "shadow-raised sm:hover:shadow-raised-hover border-0 rounded-[8px]": !isTeaser && PromoProduct_settings.websiteName === "bricostore"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                href: isTeaser ? null : "/".concat(product.url, "/cpd/").concat(product.sku, "/"),
                title: "",
                className: "block Product-photoWrapper min-w-[100px] max-w-[250px] mx-auto mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                    once: true,
                    debounce: 40,
                    offset: 400,
                    height: 120,
                    className: "Product-photo mx-auto",
                    placeholder: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(PromoProduct_settings.websiteStatics, "/images/product-image-placeholder.png"),
                        // If we have 500 products on page,
                        // adding alt increases page size by a whole lot
                        alt: "",
                        className: "Product-photo mx-auto mt-3 lg:mt-5 w-100px sm:w-120px mb-4 lg:mb-6"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: product.image.startsWith("/resize/") && "".concat(PromoProduct_settings.cdn).concat(product.image) || (0,helpers/* resizeImage */.tg)(product.image, "300x300"),
                        // If we have 500 products on page,
                        // adding alt increases page size by a whole lot
                        alt: "",
                        className: "Product-photo mx-auto".concat(PromoProduct_isBricoStore ? " rounded-t-[8px]" : "")
                    })
                })
            }),
            PromoProduct_isBricoStore && !isTeaser && !isDisabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[6px] mb-[2px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Status/* default */.Z, {
                    product: product
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                href: isTeaser ? null : "/".concat(product.url, "/cpd/").concat(product.sku, "/"),
                title: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classnames_default()("Product-nameHeading leading-20 text-sm truncate-3-lines mt-2 min-h-[57px]", {
                        "hover:text-red-brand": !isTeaser
                    }),
                    children: product.name
                })
            }),
            !isDisabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isWestaco && product.price && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "De la"
                    }),
                    getLabels().length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute ".concat(cornerLabelPos, " h-auto w-auto flex flex-col ").concat(cornerLabelBox),
                        children: (PromoProduct_isBricoStore ? getLabels().filter(function(label) {
                            return label.title;
                        }) : getLabels()).map(function(label, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductCardLabel/* default */.Z, {
                                variant: label.variant,
                                className: "truncate max-w-full",
                                children: label.title
                            }, "".concat(label.title, "-").concat(index));
                        })
                    }),
                    !PromoProduct_isBricoStore && !isTeaser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Status/* default */.Z, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-[20px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings/* default */.Z, {
                            reviewsCount: get_default()(product, "reviews_count", 0),
                            ratingSummary: get_default()(product, "reviews_value", null),
                            displayReviewsNo: true,
                            productUrl: "/".concat(product.url, "/cpd/").concat(product.sku, "/")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-auto flex items-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                            productId: parseInt(product.id),
                            price: product.final_price,
                            regularPrice: product.price,
                            formatted: true,
                            discountType: product.discount_type,
                            displayDiscount: true,
                            size: "smaller",
                            displayUnit: hasPricePerFactor && hasPriceUnit ? product.price_unit.split("/")[1] : false
                        })
                    }),
                    !isTeaser && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                        product: product,
                        isCatalog: true,
                        noMargin: true,
                        titleOnlyOnMobile: PromoProduct_settings.websiteName === "bricostore"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute ".concat(actionsPos, " flex flex-col justify-center items-center space-y-1.5"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWishlist/* default */.Z, {
                        product: product
                    }),
                    !isTeaser && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCompare/* default */.Z, {
                        product: product
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var PromoProduct = ((0,es/* connect */.$j)(null, {
    trackProductClick: actions/* trackProductClick */.Cg
})(/*#__PURE__*/ (0,react.memo)(Product)));

;// CONCATENATED MODULE: ./containers/Promo/PromoProduct/PromoProductFeatured.js

















function PromoProductFeatured_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PromoProductFeatured_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PromoProductFeatured_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PromoProductFeatured_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PromoProductFeatured_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PromoProductFeatured_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var PromoProductFeatured_ref = (0,config["default"])(), PromoProductFeatured_settings = PromoProductFeatured_ref.publicRuntimeConfig.settings;
var PromoProductFeatured_isBricoStore = PromoProductFeatured_settings.websiteName === "bricostore";
// Brico: offer label top-left; favorite/compare top-RIGHT and HIGH — identical to the small
// promo card (PromoProduct/index.js). The label's right edge (right-[52px]) stops before the
// ~32px buttons so it never runs under them, and the top inset keeps it off the card border.
var PromoProductFeatured_cornerLabelPos = PromoProductFeatured_isBricoStore ? "top-10px left-11px right-[52px] lg:top-15px lg:left-16px items-start" : "top-0 right-0 items-end";
var PromoProductFeatured_actionsPos = PromoProductFeatured_isBricoStore ? "top-10px right-11px lg:top-15px lg:right-16px" : "top-10px left-11px lg:top-15px lg:left-16px";
// Brico: don't clip the offer label's point/eyelet + small gap between labels; width is
// bounded by the left/right positions above (max-w-[85%] stays as a safety cap)
var PromoProductFeatured_cornerLabelBox = PromoProductFeatured_isBricoStore ? "overflow-visible gap-1 max-w-[85%]" : "truncate max-w-[75%]";
var PromoProductFeatured_LinkWrapper = function(_param) {
    var children = _param.children, href = _param.href, props = PromoProductFeatured_objectWithoutProperties(_param, [
        "children",
        "href"
    ]);
    if (href) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", PromoProductFeatured_objectSpread({}, props, {
                children: children
            }))
        }));
    } else {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", PromoProductFeatured_objectSpread({}, props, {
            children: children
        })));
    }
};
var PromoProductFeatured = function(param) {
    var product = param.product, isTeaser = param.isTeaser;
    var ref1 = (0,helpers/* productHelper */.gU)(product), isDisabled = ref1.isDisabled, isWestaco = ref1.isWestaco, getLabels = ref1.getLabels, hasPricePerFactor = ref1.hasPricePerFactor, hasPriceUnit = ref1.hasPriceUnit;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        // If we have 500 products on page,
        // adding title increases page size by a whole lot
        title: "",
        className: classnames_default()("Product flex flex-row items-center relative bg-white max-h-[490px]", {
            // altex/MG keep the yellow featured border; brico keeps the featured
            // border but recolored to brand red (it was accidentally border-primary = #000).
            "border-yellow border-[4px]": PromoProductFeatured_settings.websiteName !== "bricostore",
            "hover:shadow-mixRedYellow": !isTeaser,
            "shadow-raised sm:hover:shadow-raised-hover border-red-brand border-[4px] rounded-[8px]": !isTeaser && PromoProductFeatured_settings.websiteName === "bricostore"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoProductFeatured_LinkWrapper, {
                href: isTeaser ? null : "/".concat(product.url, "/cpd/").concat(product.sku, "/"),
                title: "",
                className: "block Product-photoWrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                    once: true,
                    debounce: 40,
                    offset: 400,
                    height: 120,
                    className: "Product-photo xs:w-[220px] pr-2",
                    placeholder: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(PromoProductFeatured_settings.websiteStatics, "/images/product-image-placeholder.png"),
                        // If we have 500 products on page,
                        // adding alt increases page size by a whole lot
                        alt: "",
                        className: "Product-photo xs:w-[220px] pr-2"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: product.image.startsWith("/resize/") && "".concat(PromoProductFeatured_settings.cdn).concat(product.image) || (0,helpers/* resizeImage */.tg)(product.image, "300x300"),
                        // If we have 500 products on page,
                        // adding alt increases page size by a whole lot
                        alt: "",
                        className: "Product-photo xs:w-[220px] pr-2".concat(PromoProductFeatured_isBricoStore ? " rounded-l-[8px]" : "")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-[60%] flex flex-col",
                children: [
                    PromoProductFeatured_isBricoStore && !isTeaser && !isDisabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-[6px] mb-[2px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Status/* default */.Z, {
                            product: product
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoProductFeatured_LinkWrapper, {
                        href: isTeaser ? null : "/".concat(product.url, "/cpd/").concat(product.sku, "/"),
                        title: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()("Product-nameHeading leading-20 text-sm truncate-3-lines min-h-[57px]", {
                                "hover:text-red-brand": !isTeaser,
                                // Brico: match the small card's gap between the stock badge and the title
                                "mt-2": PromoProductFeatured_isBricoStore
                            }),
                            children: product.name
                        })
                    }),
                    !isDisabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            isWestaco && product.price && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "De la"
                            }),
                            getLabels().length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute ".concat(PromoProductFeatured_cornerLabelPos, " h-auto w-auto flex flex-col ").concat(PromoProductFeatured_cornerLabelBox),
                                children: (PromoProductFeatured_isBricoStore ? getLabels().filter(function(label) {
                                    return label.title;
                                }) : getLabels()).map(function(label, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductCardLabel/* default */.Z, {
                                        variant: label.variant,
                                        className: "truncate max-w-full",
                                        children: label.title
                                    }, "".concat(label.title, "-").concat(index));
                                })
                            }),
                            !PromoProductFeatured_isBricoStore && !isTeaser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Status/* default */.Z, {
                                product: product
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[20px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings/* default */.Z, {
                                    reviewsCount: get_default()(product, "reviews_count", 0),
                                    ratingSummary: get_default()(product, "reviews_value", null),
                                    displayReviewsNo: true,
                                    productUrl: "/".concat(product.url, "/cpd/").concat(product.sku, "/")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                    productId: parseInt(product.id),
                                    price: product.final_price,
                                    regularPrice: product.price,
                                    formatted: true,
                                    discountType: product.discount_type,
                                    displayDiscount: true,
                                    size: "smaller",
                                    displayUnit: hasPricePerFactor && hasPriceUnit ? product.price_unit.split("/")[1] : false
                                })
                            }),
                            !isTeaser && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                                product: product,
                                isCatalog: true,
                                noMargin: true,
                                titleOnlyOnMobile: PromoProductFeatured_settings.websiteName === "bricostore"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute ".concat(PromoProductFeatured_actionsPos, " flex flex-col justify-center items-center space-y-1.5"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWishlist/* default */.Z, {
                        product: product
                    }),
                    !isTeaser && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCompare/* default */.Z, {
                        product: product
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var PromoProduct_PromoProductFeatured = ((0,es/* connect */.$j)(null, {
    trackProductClick: actions/* trackProductClick */.Cg
})(/*#__PURE__*/ (0,react.memo)(PromoProductFeatured)));

;// CONCATENATED MODULE: ./containers/Promo/PromoProductsGrid.js





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var PromoProductsGrid = function(param) {
    var products = param.products, sort = param.sort, filters = param.filters, campaign = param.campaign;
    var productsList = _toConsumableArray(products);
    var hasFilters = Object.keys(filters).length;
    var hasSort = sort !== "default";
    var isTeaser = campaign.is_teaser === 1;
    if (hasFilters) {
        productsList = productsList.filter(function(product) {
            if (!Object.keys(product.filterable_attributes).length) {
                return false;
            }
            var isValid = true;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(filters)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = _slicedToArray(_step.value, 2), filtername = _value[0], filterValues = _value[1];
                    if (!product.filterable_attributes[filtername] || product.filterable_attributes[filtername] && !filterValues.includes(product.filterable_attributes[filtername])) {
                        isValid = false;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return isValid;
        });
    }
    if (hasSort) {
        if (sort === "price") {
            productsList = sortBy_default()(productsList, function(product) {
                return product.final_price;
            });
        }
        if (sort === "discount") {
            productsList = sortBy_default()(productsList, function(product) {
                return product.final_price - (product.price || product.final_price);
            });
        }
    }
    if (!productsList.length && hasFilters) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "lg:mt-25px text-center text-lg font-bold group-with-promoDarkTheme:text-white",
            children: "Nu exista produse care sa corespunda filtrelor selectate."
        }));
    }
    if (!productsList.length) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "lg:mt-25px text-center text-lg font-bold group-with-promoDarkTheme:text-white",
            children: "Nu mai exista produse in aceasta categorie."
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 grid-flow-row-dense -mx-2",
        children: productsList.map(function(product) {
            var isFeatured = product.display_type === 1;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: isFeatured ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-2 Products-item p-1 md:p-2 border-2 border-transparent min-h-330px xl:min-h-400px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoProduct_PromoProductFeatured, {
                        product: product,
                        isTeaser: isTeaser
                    })
                }, product.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 Products-item p-1 md:p-2 border-2 border-transparent min-h-330px xl:min-h-400px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoProduct, {
                        product: product,
                        isTeaser: isTeaser
                    })
                }, product.id)
            }, product.id));
        })
    }));
};
/* harmony default export */ var Promo_PromoProductsGrid = (PromoProductsGrid);

// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
;// CONCATENATED MODULE: ./containers/Promo/PromoCategoryAllProducts.js








var ProductsCategoryAllProducts = function(param1) {
    var sort = param1.sort, filters = param1.filters, productsMap = param1.products, category1 = param1.category, campaign = param1.campaign;
    (0,react.useEffect)(function() {
        (0,lib/* forceCheck */.be)();
    }, [
        sort,
        filters
    ]);
    var iterateTree = function(param) {
        var category = param.category, _headingLevel = param.headingLevel, headingLevel = _headingLevel === void 0 ? 2 : _headingLevel, _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle;
        if (category.subcategories) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-6 md:mt-0",
                children: [
                    showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "group-with-promoDarkTheme:text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            display: "h".concat(headingLevel),
                            as: "h".concat(headingLevel),
                            title: category.name,
                            classesProp: "mb-4"
                        })
                    }),
                    category.subcategories.map(function(subcateg) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                            children: iterateTree({
                                category: subcateg,
                                headingLevel: showTitle ? headingLevel + 1 : headingLevel
                            })
                        }, subcateg.id);
                    })
                ]
            }, category.id));
        } else if (category.product_ids) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "mb-16",
                children: [
                    showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "group-with-promoDarkTheme:text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            display: "h".concat(headingLevel),
                            as: "h".concat(headingLevel),
                            title: category.name,
                            classesProp: "mb-4 ".concat(headingLevel > 2 ? " text-xl" : "")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoProductsGrid, {
                        products: category.product_ids.map(function(id) {
                            return productsMap[id];
                        }).filter(Boolean),
                        sort: sort,
                        category: category,
                        filters: filters,
                        campaign: campaign
                    }),
                    get_default()(category, "properties.view_all_link", "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mt-10 w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full max-w-[260px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                title: category.properties.view_all_text || "Vezi toata oferta",
                                display: "block",
                                variant: "primary",
                                href: category.properties.view_all_link
                            })
                        })
                    }),
                    get_default()(category, "properties.banner1") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-16",
                        children: get_default()(category, "properties.banner_link") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: category.properties.banner_link,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoBanner, {
                                large: category.properties.banner1,
                                medium: category.properties.banner2,
                                small: category.properties.banner3
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: category.properties && /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoBanner, {
                                large: category.properties.banner1,
                                medium: category.properties.banner2,
                                small: category.properties.banner3
                            })
                        })
                    })
                ]
            }));
        }
        return null;
    };
    return iterateTree({
        category: category1,
        headingLevel: 2,
        showTitle: false
    });
};
/* harmony default export */ var PromoCategoryAllProducts = (ProductsCategoryAllProducts);

// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __webpack_require__(18721);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
;// CONCATENATED MODULE: ./containers/Promo/PromoCategory.js







var PromoCategory_ref = (0,config["default"])(), PromoCategory_settings = PromoCategory_ref.publicRuntimeConfig.settings;
var PromoCategory = function(param) {
    var page = param.page, campaign = param.campaign, category = param.category;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            page.levels[2].active && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex flex-wrap -mx-1 md:-mx-2",
                        children: page.levels[2].subcategories.map(function(subcategory) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                className: "w-1/2 md:w-1/3 lg:w-1/4 p-1 md:p-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(PromoCategory_settings.baseUrl, "/promo/").concat(campaign.slug, "/").concat(page.levels[1].slug, "/").concat(page.levels[2].slug, "/").concat(subcategory.slug, "/"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "border-gray-1100 bg-white border   rounded-tr-lg rounded-bl-lg flex flex-col h-full p-4 text-center hover:shadow-mixRedYellow ".concat(get_default()(subcategory, "properties.icon_image", "") ? "min-h-260px lg:min-h-320px" : ""),
                                        children: [
                                            get_default()(subcategory, "properties.icon_image", "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(PromoCategory_settings.cdn).concat(subcategory.properties.icon_image),
                                                className: "flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                as: "h2",
                                                display: "h4",
                                                title: subcategory.name,
                                                classesProp: "text-18px leading-22 -tracking-0.36 md:text-2xl md:leading-28.6 md:-tracking-0.48 text-black ".concat(get_default()(subcategory, "properties.icon_image", "") ? "mt-5 md:mt-8" : "")
                                            })
                                        ]
                                    })
                                })
                            }, subcategory.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-5 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-lg mb-6 text-black group-with-promoDarkTheme:text-white",
                                children: [
                                    "Vezi toate produsele din categoria ",
                                    category.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center mt-10 w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full max-w-[260px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        title: "Vezi ".concat(page.levels[2].subcategories.reduce(function(total, elem) {
                                            return has_default()(elem, "product_count") ? total + elem.product_count : total;
                                        }, 0), " produse"),
                                        display: "block",
                                        size: "normal",
                                        variant: "primary",
                                        href: "".concat(PromoCategory_settings.baseUrl, "/promo/").concat(campaign.slug, "/").concat(page.levels[1].slug, "/").concat(page.levels[2].slug, "/toate-produsele/")
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !page.levels[2].active && page.levels[1].active && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex flex-wrap -mx-1 md:-mx-2",
                        children: page.levels[1].subcategories.map(function(subcategory) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                className: "w-1/2 md:w-1/3 lg:w-1/4 p-1 md:p-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "".concat(PromoCategory_settings.baseUrl, "/promo/").concat(campaign.slug, "/").concat(page.levels[1].slug, "/").concat(subcategory.slug, "/"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "border-gray-1100 bg-white border   rounded-tr-lg rounded-bl-lg block p-4 text-center hover:shadow-mixRedYellow ".concat(get_default()(subcategory, "properties.icon_image", "") ? "min-h-260px lg:min-h-320px" : ""),
                                            children: [
                                                get_default()(subcategory, "properties.icon_image", "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(PromoCategory_settings.cdn).concat(subcategory.properties.icon_image),
                                                    className: "flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10",
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                    as: "h2",
                                                    display: "h4",
                                                    title: subcategory.name,
                                                    classesProp: "text-18px leading-22 -tracking-0.36 md:text-2xl md:leading-28.6 md:-tracking-0.48 text-black ".concat(get_default()(subcategory, "properties.icon_image", "") ? "mt-5 md:mt-8" : "")
                                                })
                                            ]
                                        })
                                    }),
                                    subcategory.subcategories && subcategory.subcategories.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "p-0 px-3 mt-2",
                                        children: subcategory.subcategories.map(function(subSubCategory) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: "".concat(PromoCategory_settings.baseUrl, "/promo/").concat(campaign.slug, "/").concat(page.levels[1].slug, "/").concat(subcategory.slug, "/").concat(subSubCategory.slug, "/"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "py-1 block text-sm underline text-black hover:text-red-brand group-with-promoDarkTheme:text-gray-light",
                                                        title: "",
                                                        children: subSubCategory.name
                                                    })
                                                })
                                            }, subSubCategory.id);
                                        })
                                    })
                                ]
                            }, subcategory.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-5 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-lg mb-6 text-black group-with-promoDarkTheme:text-white",
                                children: [
                                    "Vezi toate produsele din categoria ",
                                    category.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center mt-10 w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full max-w-[260px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        title: "Vezi ".concat(page.levels[1].subcategories.reduce(function(total, lvl1) {
                                            if (lvl1.subcategories) {
                                                return total + lvl1.subcategories.reduce(function(totalChild, elem) {
                                                    return has_default()(elem, "product_count") ? totalChild + elem.product_count : totalChild;
                                                }, 0);
                                            } else if (has_default()(lvl1, "product_count")) {
                                                return total + lvl1.product_count;
                                            } else {
                                                return total;
                                            }
                                        }, 0), " produse"),
                                        display: "block",
                                        size: "normal",
                                        variant: "primary",
                                        href: "".concat(PromoCategory_settings.baseUrl, "/promo/").concat(campaign.slug, "/").concat(page.levels[1].slug, "/toate-produsele/")
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Promo_PromoCategory = (PromoCategory);

;// CONCATENATED MODULE: ./containers/Promo/PromoProducts.js







var findSiblingCategories = function(currentCategory, categories, campaign) {
    var allCategories = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // TODO: deadline and 4:20 in the morning, recursion..
        // Categories lvl 1
        for(var _iterator = categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            if (category.product_ids && !category.subcategories) {
                allCategories.push({
                    id: category.id,
                    name: category.name,
                    url: "/promo/".concat(campaign.slug, "/").concat(category.slug, "/")
                });
            }
            if (category.subcategories) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Categories lvl 2
                    for(var _iterator1 = category.subcategories[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var subcategory = _step1.value;
                        if (subcategory.product_ids && !subcategory.subcategories) {
                            allCategories.push({
                                id: subcategory.id,
                                name: subcategory.name,
                                url: "/promo/".concat(campaign.slug, "/").concat(category.slug, "/").concat(subcategory.slug, "/")
                            });
                        }
                        if (subcategory.subcategories) {
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                // Categories lvl 3
                                for(var _iterator2 = subcategory.subcategories[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var subSubcategory = _step2.value;
                                    allCategories.push({
                                        id: subSubcategory.id,
                                        name: subSubcategory.name,
                                        url: "/promo/".concat(campaign.slug, "/").concat(category.slug, "/").concat(subcategory.slug, "/").concat(subSubcategory.slug, "/")
                                    });
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var currentCategoryIndex = allCategories.findIndex(function(category) {
        return category.id === currentCategory.id;
    });
    return {
        previousCategory: allCategories[currentCategoryIndex - 1],
        nextCategory: allCategories[currentCategoryIndex + 1]
    };
};
var PromoProducts = function(param) {
    var sort = param.sort, filters = param.filters, categories = param.categories, productsMap = param.products, category = param.category, campaign = param.campaign;
    (0,react.useEffect)(function() {
        (0,lib/* forceCheck */.be)();
    }, [
        sort,
        filters
    ]);
    var ref = findSiblingCategories(category, categories, campaign), previousCategory = ref.previousCategory, nextCategory = ref.nextCategory;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoProductsGrid, {
                products: (category.product_ids || []).map(function(id) {
                    return productsMap[id];
                }).filter(Boolean),
                sort: sort,
                filters: filters,
                campaign: campaign
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden lg:flex justify-between items-center mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sm:w-full sm:max-w-[220px]",
                        children: previousCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            title: "Categoria anterioara",
                            display: "block",
                            variant: "third",
                            classesProp: "group-with-promoDarkTheme:bg-transparent group-with-promoDarkTheme:text-white",
                            href: previousCategory.url
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center w-full",
                        children: get_default()(category, "properties.view_all_link", "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full max-w-[260px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                title: category.properties.view_all_text || "Vezi toata oferta",
                                display: "block",
                                variant: "primary",
                                href: category.properties.view_all_link
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sm:w-full sm:max-w-[220px]",
                        children: nextCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            title: "Categoria urmatoare",
                            display: "block",
                            variant: "third",
                            classesProp: "group-with-promoDarkTheme:bg-transparent group-with-promoDarkTheme:text-white",
                            href: nextCategory.url
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "block lg:hidden mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center w-full",
                        children: nextCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                title: "".concat(nextCategory.name, " →"),
                                display: "block",
                                variant: "third",
                                href: nextCategory.url,
                                classesProp: "group-with-promoDarkTheme:bg-transparent group-with-promoDarkTheme:text-white"
                            })
                        })
                    }),
                    get_default()(category, "properties.view_all_link", "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                title: category.properties.view_all_text || "Vezi toata oferta",
                                display: "block",
                                variant: "primary",
                                href: category.properties.view_all_link
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center w-full",
                        children: previousCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                title: "← ".concat(previousCategory.name),
                                display: "block",
                                variant: "third",
                                href: previousCategory.url,
                                classesProp: "group-with-promoDarkTheme:bg-transparent group-with-promoDarkTheme:text-white"
                            })
                        })
                    })
                ]
            }),
            get_default()(category, "properties.banner1") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-16",
                children: category.properties.banner_link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: category.properties.banner_link,
                    title: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoBanner, {
                        large: category.properties.banner1,
                        medium: category.properties.banner2,
                        small: category.properties.banner3
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoBanner, {
                    large: category.properties.banner1,
                    medium: category.properties.banner2,
                    small: category.properties.banner3
                })
            })
        ]
    }));
};
/* harmony default export */ var Promo_PromoProducts = (PromoProducts);

// EXTERNAL MODULE: ./containers/Catalog/CompareWidget.js + 1 modules
var CompareWidget = __webpack_require__(1144);
;// CONCATENATED MODULE: ./containers/Promo/PromoFooter.js

var PromoFooter = function(param) {
    var links = param.links;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("footer", {
        className: "u-space-pt-5 u-text-link-inherit-color bg-transparent text-inherit",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container u-space-pb-30 u-space-pt-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "List List--inline List--separator u-space-mb-30 group-with-promoDarkTheme:text-white",
                    children: links.map(function(link, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: link.url,
                                title: "",
                                children: link.title
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-10",
                    children: "\xa0"
                })
            ]
        })
    });
};
/* harmony default export */ var Promo_PromoFooter = (PromoFooter);

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
;// CONCATENATED MODULE: ./containers/Promo/PromoScrollTop.js



var PromoScrollTop_ref = (0,config["default"])(), PromoScrollTop_publicRuntimeConfig = PromoScrollTop_ref.publicRuntimeConfig, PromoScrollTop_websiteName = PromoScrollTop_publicRuntimeConfig.settings.websiteName;
var PromoScrollTop_isBricoStore = PromoScrollTop_websiteName === "bricostore";
var PromoScrollTop = function() {
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#",
                onClick: function(event) {
                    event.preventDefault();
                    window.scrollTo(0, 0);
                },
                className: style_default().dynamic([
                    [
                        "c5287d38edfd52c9",
                        [
                            PromoScrollTop_isBricoStore ? "50%" : "3px",
                            PromoScrollTop_isBricoStore ? "#da281a" : "#d71440"
                        ]
                    ]
                ]) + " " + "scrollTop"
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "c5287d38edfd52c9",
                dynamic: [
                    PromoScrollTop_isBricoStore ? "50%" : "3px",
                    PromoScrollTop_isBricoStore ? "#da281a" : "#d71440"
                ],
                /*#__PURE__*/ children: ".scrollTop.__jsx-style-dynamic-selector{display:block;\nz-index:2;\nposition:fixed;\ncursor:pointer;\nbottom:30px;\nleft:5%;\nheight:44px;\nwidth:44px;\noverflow:hidden;\nborder-radius:".concat(PromoScrollTop_isBricoStore ? "50%" : "3px", ";\nbackground-color:rgba(255, 255, 255, 0.9);\n-webkit-box-shadow:0 1px 1px 1px rgba(0, 0, 0, 0.3);\nbox-shadow:0 1px 1px 1px rgba(0, 0, 0, 0.3)}\n.scrollTop.__jsx-style-dynamic-selector:after{content:\"\";\ndisplay:inline-block;\nmargin-top:18px;\nmargin-left:13px;\nwidth:18px;\nheight:18px;\nborder-top:3px solid #333;\nborder-right:3px solid #333;\n-webkit-transform:rotate(-45deg);\n-webkit-transform:rotate(-45deg);\n-moz-transform:rotate(-45deg);\n-ms-transform:rotate(-45deg);\ntransform:rotate(-45deg)}\n.scrollTop.__jsx-style-dynamic-selector:hover:after{border-color:").concat(PromoScrollTop_isBricoStore ? "#da281a" : "#d71440", "}")
            })
        ]
    }));
};
/* harmony default export */ var Promo_PromoScrollTop = (PromoScrollTop);

;// CONCATENATED MODULE: ./containers/Promo/PromoProductsSort.js



var PromoProductsSort_ref = (0,config["default"])(), PromoProductsSort_settings = PromoProductsSort_ref.publicRuntimeConfig.settings;
var PromoProductsSort = function(param) {
    var value = param.value, onChange = param.onChange;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)("div", {
        className: style_default().dynamic([
            [
                "10beed2c537c735c",
                [
                    PromoProductsSort_settings.websiteStatics
                ]
            ]
        ]) + " " + "sm:flex items-center Form-select",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "promo-sort-select",
                className: style_default().dynamic([
                    [
                        "10beed2c537c735c",
                        [
                            PromoProductsSort_settings.websiteStatics
                        ]
                    ]
                ]) + " " + "hidden sm:block whitespace-nowrap sm:mr-4 group-with-promoDarkTheme:text-white",
                /*#__PURE__*/ children: "Sorteaza dupa"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                value: value,
                onChange: function(event) {
                    return onChange(event.target.value);
                },
                id: "promo-sort-select",
                className: style_default().dynamic([
                    [
                        "10beed2c537c735c",
                        [
                            PromoProductsSort_settings.websiteStatics
                        ]
                    ]
                ]) + " " + "promo-sort-select group-with-promoDarkTheme:bg-[#686868] group-with-promoDarkTheme:text-white group-with-promoDarkTheme:border-[#686868]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "default",
                        className: style_default().dynamic([
                            [
                                "10beed2c537c735c",
                                [
                                    PromoProductsSort_settings.websiteStatics
                                ]
                            ]
                        ]),
                        children: "Sortare implicita"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "price",
                        className: style_default().dynamic([
                            [
                                "10beed2c537c735c",
                                [
                                    PromoProductsSort_settings.websiteStatics
                                ]
                            ]
                        ]),
                        children: "Cel mai mic pret"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "discount",
                        className: style_default().dynamic([
                            [
                                "10beed2c537c735c",
                                [
                                    PromoProductsSort_settings.websiteStatics
                                ]
                            ]
                        ]),
                        children: "Cea mai mare reducere"
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "10beed2c537c735c",
                dynamic: [
                    PromoProductsSort_settings.websiteStatics
                ],
                children: ".group.group-promoDarkTheme .promo-sort-select{background-image:url(\"".concat(PromoProductsSort_settings.websiteStatics, "/images/icons/down-arrow-white.svg\")}")
            })
        ]
    }));
};
/* harmony default export */ var Promo_PromoProductsSort = (PromoProductsSort);

;// CONCATENATED MODULE: ./containers/Promo/PromoMobileProductsSort.js

var PromoMobileProductsSort = function(param) {
    var value = param.value, onChange = param.onChange;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("select", {
        value: value,
        onChange: function(event) {
            return onChange(event.target.value);
        },
        className: "max-w-full py-2 px-5 border rounded-bl-lg rounded-tr-lg bg-white border-primary w-full h-[50px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "default",
                children: "Sortare implicita"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "price",
                children: "Cel mai mic pret"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "discount",
                children: "Cea mai mare reducere"
            })
        ]
    });
};
/* harmony default export */ var Promo_PromoMobileProductsSort = (PromoMobileProductsSort);

;// CONCATENATED MODULE: ./containers/Promo/PromoBreadcrumbs.js




var PromoBreadcrumbs_ref = (0,config["default"])(), PromoBreadcrumbs_settings = PromoBreadcrumbs_ref.publicRuntimeConfig.settings;
var PromoBreadcrumbs_isBricoStore = PromoBreadcrumbs_settings.websiteName === "bricostore";
// Brico: match the site breadcrumbs (components/Breadcrumbs.js) — brand red + text-sm,
// instead of the promo-only magenta #C50244; altex/MG keep the original look.
var linkClass = "".concat(PromoBreadcrumbs_isBricoStore ? "text-red-brand" : "text-[#C50244]", " group-with-promoDarkTheme:text-white");
var PromoBreadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, campaignSlug = param.campaignSlug;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: PromoBreadcrumbs_isBricoStore ? "text-sm" : "text-xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "".concat(PromoBreadcrumbs_settings.baseUrl, "/promo/").concat(campaignSlug, "/"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: "",
                    className: linkClass,
                    children: "Pagina principala"
                })
            }),
            breadcrumbs.map(function(breadcrumb, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: linkClass,
                            children: " / "
                        }),
                        breadcrumb.active ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-gray-text",
                            children: breadcrumb.name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "".concat(PromoBreadcrumbs_settings.baseUrl, "/promo/").concat(campaignSlug, "/").concat(breadcrumb.slug, "/"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: "",
                                className: linkClass,
                                children: breadcrumb.name
                            })
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var Promo_PromoBreadcrumbs = (PromoBreadcrumbs);

;// CONCATENATED MODULE: ./containers/Promo/PromoHomepageCategories.js






var PromoHomepageCategories_ref = (0,config["default"])(), PromoHomepageCategories_settings = PromoHomepageCategories_ref.publicRuntimeConfig.settings;
var PromoHomepageCategories = function(param) {
    var campaign = param.campaign, tree = param.tree;
    if (tree && tree.length > 0) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "flex flex-wrap -mx-1 md:-mx-2 py-6",
            children: tree.map(function(subcategory) {
                var ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                    className: "w-1/2 md:w-1/3 lg:w-1/5 p-1 md:p-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "".concat(PromoHomepageCategories_settings.baseUrl, "/promo/").concat(campaign.slug, "/").concat(subcategory.slug, "/"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "border-gray-1100 bg-white border rounded-tr-lg rounded-bl-lg min-h-260px lg:min-h-320px flex flex-col h-full p-4 text-center hover:shadow-mixRedYellow",
                            children: [
                                (subcategory === null || subcategory === void 0 ? void 0 : (ref1 = subcategory.properties) === null || ref1 === void 0 ? void 0 : ref1.icon_image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,helpers/* resizeImage */.tg)(subcategory.properties.icon_image, "300x300"),
                                    className: "flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h2",
                                    display: "h4",
                                    title: subcategory.name,
                                    classesProp: "break-words mt-5 text-[22px] leading-20 -tracking-0.36"
                                })
                            ]
                        })
                    })
                }, subcategory.id);
            })
        }));
    }
    return null;
};
/* harmony default export */ var Promo_PromoHomepageCategories = (PromoHomepageCategories);

;// CONCATENATED MODULE: ./containers/Promo/index.js




















function Promo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Promo_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Promo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Promo_ref = (0,config["default"])(), Promo_publicRuntimeConfig = Promo_ref.publicRuntimeConfig, Promo_websiteName = Promo_publicRuntimeConfig.settings.websiteName;
var Promo_isBricoStore = Promo_websiteName === "bricostore";
var Promo = function(param1) {
    var campaign = param1.campaign, tree = param1.tree, category = param1.category, products = param1.products, page = param1.page, context = param1.context;
    var ref4;
    var ref1 = (0,react.useState)("default"), sortType = ref1[0], setSortType = ref1[1];
    var ref2 = (0,react.useState)({}), filters = ref2[0], setFilters = ref2[1];
    var ref3 = (0,react.useState)(false), isMobileFiltersVisible = ref3[0], setMobileFiltersVisibility = ref3[1];
    var hasProducts = page.layout === "products" || page.layout === "all-products";
    var hasMenu = tree && tree.length > 1 || tree && tree.length === 1 && ((ref4 = tree[0].subcategories) === null || ref4 === void 0 ? void 0 : ref4.length) > 0;
    var hasFooterLinks = get_default()(campaign, "properties.footer_links", []).length !== 0;
    var hasFilters = category.filters;
    var hasBanner = get_default()(campaign, "properties.banner1", "");
    var hasDarkTheme = page.theme === "dark";
    (0,react.useEffect)(function() {
        setSortType("default");
        setFilters({});
    }, [
        category.id,
        page.layout
    ]);
    var handleSortTypeChange = function(type) {
        return setSortType(type);
    };
    var handleMobileFiltersVisibility = function() {
        return setMobileFiltersVisibility(!isMobileFiltersVisible);
    };
    var handleFiltersChange = (0,react.useCallback)(function(param) {
        var filter = param.filter, option = param.option;
        var newFilters = Promo_objectSpread({}, filters);
        // Filter is already set
        if (newFilters[filter.attribute_code]) {
            var filterValueIndex = newFilters[filter.attribute_code].indexOf(option.value);
            // Update existing filter
            if (filterValueIndex > -1) {
                newFilters[filter.attribute_code].splice(filterValueIndex, 1);
                // Delete filter if it has no options set
                if (!newFilters[filter.attribute_code].length) {
                    delete newFilters[filter.attribute_code];
                }
            } else {
                // Add filter option
                newFilters[filter.attribute_code].push(option.value);
            }
        } else {
            // Create filter
            newFilters[filter.attribute_code] = [
                option.value
            ];
        }
        setFilters(newFilters);
    }, [
        filters
    ]);
    var isTeaser = campaign.is_teaser === 1;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: hasDarkTheme ? "group group-promoDarkTheme bg-[#111111]" : "bg-gray-100",
        children: [
            hasBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoBanner, {
                    large: campaign.properties.banner1,
                    medium: campaign.properties.banner2,
                    small: campaign.properties.banner3
                })
            }),
            page.layout !== "homepage-categories" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    hasMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoMobileMenu, {
                            currentPageCategory: category.id,
                            categories: tree,
                            context: context,
                            campaignSlug: campaign.slug
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-7xl mx-auto px-3 md:px-4",
                        children: [
                            hasMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-2 lg:pt-5 ".concat(Promo_isBricoStore ? "mb-3 lg:mb-4" : "mb-8 lg:mb-12"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoBreadcrumbs, {
                                    campaignSlug: campaign.slug,
                                    breadcrumbs: page.breadcrumbs
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:flex ".concat(Promo_isBricoStore ? "mt-2 lg:mt-3" : "mt-10"),
                                children: [
                                    hasMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden lg:block w-full max-w-[232px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(hasMenu ? "lg:pl-8 " : "", "w-full").concat(Promo_isBricoStore ? " lg:flex lg:items-center lg:justify-between lg:gap-4" : ""),
                                        children: [
                                            page.heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(Promo_isBricoStore ? "mb-2 lg:mb-0" : "mb-5", " group-with-promoDarkTheme:text-white"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                    display: "h1",
                                                    as: "h1",
                                                    title: page.heading
                                                })
                                            }),
                                            hasProducts && !isTeaser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "hidden lg:flex lg:justify-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoProductsSort, {
                                                    value: sortType,
                                                    onChange: handleSortTypeChange
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (hasProducts || hasFilters) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-col-reverse flex sm:flex-row lg:hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full sm:w-1/2",
                                        children: hasFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoMobileProductsFiltersToggle, {
                                            onClick: handleMobileFiltersVisibility,
                                            isActive: isMobileFiltersVisible
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full sm:w-1/2 sm:pl-4 mb-3 sm:mb-0",
                                        children: hasProducts && !isTeaser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoMobileProductsSort, {
                                            value: sortType,
                                            onChange: handleSortTypeChange
                                        })
                                    })
                                ]
                            }),
                            hasFilters && isMobileFiltersVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoMobileProductsFilters, {
                                    filters: category.filters,
                                    activeFilters: filters,
                                    onFiltersChange: handleFiltersChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:flex ".concat(Promo_isBricoStore ? "mt-3 lg:mt-4" : "mt-10", " pb-32"),
                                children: [
                                    hasMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                                        className: "hidden lg:block w-full max-w-[232px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoMainMenu, {
                                            currentPageCategory: category.id,
                                            categories: tree,
                                            context: context,
                                            campaignSlug: campaign.slug,
                                            activeFilters: filters,
                                            onFiltersChange: handleFiltersChange
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                        className: hasMenu ? "lg:pl-8 w-full" : "w-full",
                                        children: [
                                            page.layout === "products" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoProducts, {
                                                category: category,
                                                categories: tree,
                                                products: products,
                                                context: context,
                                                campaign: campaign,
                                                sort: sortType,
                                                filters: filters
                                            }),
                                            page.layout === "all-products" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoCategoryAllProducts, {
                                                page: page,
                                                campaign: campaign,
                                                context: context,
                                                category: category,
                                                products: products,
                                                filters: filters,
                                                sort: sortType
                                            }),
                                            page.layout === "category" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoCategory, {
                                                page: page,
                                                campaign: campaign,
                                                category: category
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-7xl mx-auto px-3 md:px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoHomepageCategories, {
                        campaign: campaign,
                        tree: tree
                    })
                })
            }),
            hasFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoFooter, {
                links: campaign.properties.footer_links
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Promo_PromoScrollTop, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareWidget/* default */.Z, {})
        ]
    }));
};
/* harmony default export */ var containers_Promo = (Promo);


/***/ })

}]);